import React, { useEffect, useState } from "react";

import { Box, Typography, Divider, Tabs, Tab, Button } from "@mui/material";
import { Coaches } from "./Coaches";
import { Players } from "./Players";
import { useUser } from "../../../contexts/UserContext";

export const Users = () => {
  const { users, fetchUsers, user } = useUser();
  const [selectedTab, setSelectedTab] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    if (user) {
      setLoading(false);
    }
  }, [user]);

  const coaches = users.filter((user) => user.user_type === "COACH" || user.user_type === "coach");
  const players = users.filter((user) => user.user_type === "PLAYER");

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };
  return (
    <Box sx={{ flex: 1, p: 1 }}>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "rgba(123, 45, 58, 0.9)",
          },
          "& .MuiTab-root": {
            color: "rgba(255, 255, 255, 0.7)",
            "&.Mui-selected": {
              color: "white",
            },
          },
        }}
      >
        <Tab key={0} label={"Coaches"} id={`admin-tab-0`} />
        <Tab key={1} label={"Players"} id={`admin-tab-1`} />
      </Tabs>
      <Divider />
      {selectedTab === 0 && <Coaches coaches={coaches} currentUser={user} />}
      {selectedTab === 1 && <Players players={players} />}
    </Box>
  );
};
